import { IUploadLogCustomFilter, IUploadLogFilter } from '~/client/graph'
import {
  DeleteUploadLogCustomFilterDocument,
  SaveUploadLogCustomFilterDocument,
} from '~/client/graph/operations/generated/CustomUploadLogFilters.generated'

import CustomUploadLogFilter from '../../types/CustomUploadLogFilter'
import BaseCustomListFiltersStore from '../BaseCustomListFilters.store'

export default class CustomUploadLogFiltersStore extends BaseCustomListFiltersStore<
  CustomUploadLogFilter,
  IUploadLogCustomFilter
> {
  protected readonly saveMutationDoc = SaveUploadLogCustomFilterDocument
  protected readonly deleteMutationDoc = DeleteUploadLogCustomFilterDocument

  public get byId(): Map<string, CustomUploadLogFilter> {
    return this.eventsStore.appState.customUploadLogFilters
  }

  public createCopy(original: CustomUploadLogFilter): CustomUploadLogFilter {
    const name = original.name + ' - Copy'
    const defaultForUsers = [...original.defaultForUsers]
    const filtersByFilterType = original.filtersByFilterType.map(
      filter =>
        ({ type: filter.type, values: [...filter.values] }) as IUploadLogFilter,
    )
    return new CustomUploadLogFilter(
      null,
      name,
      original.isPublic,
      original.projectId,
      original.userId,
      defaultForUsers,
      filtersByFilterType,
      original.groupBy,
    )
  }

  public async saveCustomFilter(
    filter: CustomUploadLogFilter,
  ): Promise<string> {
    const result = await this.saveOne(filter)

    return result?.saveUploadLogCustomFilter?.id
  }

  public getInstanceFromDto(
    dto: IUploadLogCustomFilter,
  ): CustomUploadLogFilter {
    return CustomUploadLogFilter.fromDto(dto)
  }

  public createFromValues(
    filtersByFilterType: IUploadLogFilter[],
    isPublic: boolean,
    defaultForUsers: string[],
  ): CustomUploadLogFilter {
    return new CustomUploadLogFilter(
      null,
      '',
      isPublic,
      this.activeProjectId,
      this.activeUserId,
      defaultForUsers,
      filtersByFilterType,
      '',
    )
  }
}
